import React, { useState, useEffect } from 'react';
import { FaTimes } from 'react-icons/fa';
import homepage from '../../cms/homepage.json';
import '../../css/common/WelcomeBanner.css';

const welcomeBannerConfig = homepage.welcomeBanner || {};

const WelcomeBanner = ({ onClose }) => {
  const [isAnimating, setIsAnimating] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [isClosed, setIsClosed] = useState(false);

  // Check if banner should be active (flag + date window)
  const { isActive: flag, startDate, endDate } = welcomeBannerConfig;
  const now = new Date();
  const starts = startDate ? new Date(startDate) : null;
  const ends = endDate ? new Date(endDate) : null;
  const activeByDate = (!starts || now >= starts) && (!ends || now <= ends);
  const isActive = flag && activeByDate;
  
  useEffect(() => {
    if (!isActive || isClosed) return;

    // Trigger animation after a short delay
    const timer = setTimeout(() => {
      setIsAnimating(true);
    }, 500); // Short delay for immediate animation

    return () => clearTimeout(timer);
  }, [isActive, isClosed]);

  const handleClose = () => {
    setIsClosing(true);
    // Notify parent component
    if (onClose) {
      onClose();
    }
    // Actually close after animation completes
    setTimeout(() => {
      setIsClosed(true);
    }, 400); // Match the CSS transition duration
  };

  // Don't render if not active or closed
  if (!isActive || isClosed) {
    return null;
  }

  return (
    <div className={`welcome-banner ${isAnimating ? 'animate' : ''} ${isClosing ? 'closing' : ''}`}>
      <div className="welcome-banner-content">
        <div className="welcome-banner-text">
          <h3 className="welcome-banner-title">{welcomeBannerConfig.message}</h3>
          <p className="welcome-banner-subtitle">{welcomeBannerConfig.subtitle}</p>
        </div>
        <button 
          className="welcome-banner-close" 
          onClick={handleClose}
          aria-label="Close welcome message"
        >
          <FaTimes />
        </button>
      </div>
    </div>
  );
};

export default WelcomeBanner; 